export enum Language {
	en = "en-US",
	cs = "cs-CZ",
	sk = "sk-SK",
	gb = "en-GB",
}

export type Languages = {
	id: Language;
	icon: string;
	name: string;
}[];
